// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqsPage_container__3ycGA","faqs":"FaqsPage_faqs__2x49_","faqsHeader":"FaqsPage_faqsHeader__1xHXk","faqsHeaderConatiner":"FaqsPage_faqsHeaderConatiner__2WtyY"};